import React from 'react'
import Header from '../Components/Header'
import Footer from '../Components/Footer'

function AboutUs() {
    return (
        <div className="accent-custom">
             <Header />
            <main>
                {/* breadcrumb area start */}
                <section className="breadcrumb__area include-bg pt-20">
                    <div className="container">
                        <div className="row">
                            <div className="col-xxl-12">
                                <div className="breadcrumb__content p-relative z-index-1">
                                    <div className="breadcrumb__list">
                                        <span><a>Home</a></span>
                                        <span><a >About Us</a></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {/* breadcrumb area end */}
                {/* shop area start */}
                <section className="tp-product-details-area pb-50">
                    <div className="container">
                        <div className="row pt-30">
                            <div className="col-xl-12 col-lg-12">
                                <h3 className="tp-section-title text-center">About Us</h3>
                            </div> {/* col end */}
                        </div>
                        <div className="row pt-30">
                            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                <p>For over 25 years, we have worked creatively to bring specialized savings and consumer promotions directly to the active and retired Military families worldwide via an array of in-store coupons and displays.</p>
                                <p>If you've shopped the Commissaries through the years, you have undoubtedly benefited from the additional savings these programs provide in the form of at-shelf coupons and other discount display offers.</p>
                                <p>Now, thanks to a potent combination of the Internet, social media and our unrivaled years of experience servicing the military - Military Families can reap savings and promotions like never before via MyMilitarySavings.com.</p>
                                <p>MyMilitarySavings.com is an Exclusive Military online savings, discount, promotion and recipe destination of choice for all active and retired military families worldwide. We encourage you to browse our site regularly for continuous promotions, exciting contests and giveaways, but most importantly, visit us for savings that you will truly enjoy. Thank you for your service to our great country.</p>
                                <h5 className="pt-15 pb-15">Serve. Save. Enjoy</h5>
                            </div>
                            {/* <div class="col-xl-5 col-lg-5 col-md-12 col-sm-12 col-12">
               <div class="about_img text-center"><img src="assets/img/about/about.jpg" border="0" alt="About Us"/></div>

            </div> */}
                        </div>
                        {/* <div class="row pt-30">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">

                 <div class="videoWrapper">
                     <iframe width="560" height="315" src="https://www.youtube.com/embed/IlAVVP_3f08?si=bjDfb7p6FSfeDF6w" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                 </div>
            </div>
          </div> */}
                    </div>
                </section>
                {/* shop area end */}
            </main>
            <Footer />
        </div>
    )
}

export default AboutUs